 
import React from 'react';
 import Scheduler from 'components/scheduler/scheduler';
import { Card, CardContent, CardHeader } from 'components';
import { NewOrdersCard, NomStatisticsCard } from './cards';
import styles from './dashboard.module.scss';


export const Dashboard = () => (
    <div className={styles.container}>
      <div className={styles.column}>
        <NewOrdersCard />
        <NomStatisticsCard />
      </div>
      <div className={styles.column}>
        <Card>
          <CardHeader title={'розклад'} />
          <CardContent>
            <Scheduler />
          </CardContent>
        </Card>
      </div>
    </div>
);
